export default __webpack_public_path__ + "src/images/sections/7b5c8ebb0686e61657ff5db53ea5fc43-book.jpg";